module.exports = __webpack_public_path__ + "img/12.58079b72.png";